export const checkinModalGlobal = {
  header: {
    phone: "Téléphone",
    accommodation: "Hébergement",
    checkin: "Check-in",
    booking: "Réservation",
    notAvailable: "Non disponible",
    notLinked: "Non associé",
    defaultGuestName: "Client",
  },
  roles: {
    botStaff: "BOT / STAFF",
    guest: "GUEST",
  },
  media: {
    imageAlt: "Image envoyée",
    locationReceived: "📍 Position reçue",
    openInMaps: "Ouvrir dans Google Maps",
    viewCoordinates: "Voir les coordonnées ({lat}, {lng})",
    viewFile: "Voir le fichier",
    document: "Document",
  },
  dropzone: {
    text: "Déposez pour joindre des fichiers",
  },
  failure: {
    notSent: "Non envoyé",
    notSentDefault: "Non envoyé",
    reasons: {
      paymentIssue: "problème de paiement sur le compte WhatsApp",
      cannotReceive: "le numéro ne peut pas recevoir de messages WhatsApp",
      downloadFailed: "WhatsApp n'a pas pu télécharger le fichier",
      templateMissingData: "des données manquent dans le modèle",
      requirementsNotMet: "le message ne respecte pas les exigences de WhatsApp",
    },
  },
  mode: {
    ai: "IA",
    manual: "Manuel",
    autoReplyBanner: "L'agent répond automatiquement à ce client.",
  },
  predefined: {
    header: "Réponses prédéfinies",
    empty: "Aucune réponse prédéfinie trouvée",
  },
  input: {
    attachFile: "Joindre un fichier",
    placeholder: "Commencez par / pour choisir une réponse prédéfinie.",
    removeFile: "Retirer le fichier",
  },
  toasts: {
    noBookingLinkedSummary: "Aucune réservation associée",
    noBookingLinkedDetail: "Aucune réservation n'est associée à cette conversation",
    errorSummary: "Erreur",
    userIdError: "Impossible d'obtenir l'identifiant utilisateur",
    manualModeSummary: "Mode manuel activé",
    aiModeSummary: "Agent IA activé",
    manualModeDetail: "Vous répondrez aux messages manuellement",
    aiModeDetail: "Le bot répondra automatiquement",
    modeChangeError: "Impossible de changer le mode de la conversation",
    reactivateIdError: "Impossible d'identifier la conversation à réactiver.",
    successSummary: "Succès",
    templateSentOk: "Modèle envoyé avec succès.",
    templateSentError: "Impossible d'envoyer le modèle de réactivation.",
    fileTypeSummary: "Type de fichier non autorisé",
    fileTypeDetail: "{name} n'est pas une image ni un PDF.",
    fileSizeSummary: "Fichier trop volumineux",
    fileSizeDetail: "{name} dépasse la limite de 5 Mo.",
    sendError: "Impossible d'envoyer le message",
  },
};
